'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadClassesFromSchemas = exports.isUserInRole = exports.createRoleIfNotExists = exports.saveAllInChunks = exports.deleteAllByQuery = exports.findAll = exports.getRoleByName = exports.getUserById = exports.getUserByEmail = exports.uploadFile = exports.setArrayOfPointers = exports.setPointer = exports.setField = exports.getObjectWithoutParseAttributes = exports.createPointerFromId = exports.initializeParseSDK = exports.setParseLib = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = require('lodash');

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var Parse = global.Parse;

/**
 * Set the Parse library to use (node/react-native).
 * @param {Object} parseLib - The Parse library instance.
 */
var setParseLib = exports.setParseLib = function setParseLib(parseLib) {
  Parse = parseLib;
};

/**
 * Initialize the Parse SDK.
 * @category Synchronous.
 * @param {String} serverURL
 * @param {String} appId
 * @param {String} masterKey
 */
var initializeParseSDK = exports.initializeParseSDK = function initializeParseSDK(serverURL, appId, masterKey) {
  Parse.initialize(appId, '', masterKey);
  Parse.serverURL = serverURL;
};

/**
 * Create a pointer to a Parse object given its id and the class name.
 * @category Synchronous.
 * @param {String} className - The class name of the Parse object.
 * @param {String} objectId - The id of the Parse object.
 * @return {ParsePointer} Pointer to the Parse object.
 */
var createPointerFromId = exports.createPointerFromId = function createPointerFromId(className, objectId) {
  var objClass = Parse.Object.extend(className);
  var obj = new objClass();
  obj.id = objectId;
  return obj;
};

/**
 * Strip off the Parse specific attributes from an Object.
 * @category Synchronous.
 * @param {Object} object - Plain Javascript representation of a Parse Object.
 * @return {Object} Object without the Parse specific attributes.
 */
var getObjectWithoutParseAttributes = exports.getObjectWithoutParseAttributes = function getObjectWithoutParseAttributes(object) {
  var PARSE_SPECIFIC_ATTRIBUTES = ['__type', 'className', 'objectId', 'createdAt', 'updatedAt', 'ACL'];
  return (0, _lodash.omit)(_extends({}, object), PARSE_SPECIFIC_ATTRIBUTES);
};

/**
 * Set the value of Parse object field (it mutates the object).
 * @category Synchronous.
 * @param {ParseObject} parseObject - The Parse object with the field that must be set.
 * @param {String} fieldName - The name of the field.
 * @param {Number|Boolean|String|Array|ParseObject} fieldValue - The value of the field.
 */
var setField = exports.setField = function setField(parseObject, fieldName, fieldValue) {
  if (!(0, _lodash.isNil)(fieldValue)) {
    parseObject.set(fieldName, fieldValue, {});
  } else {
    parseObject.unset(fieldName);
  }
};

/**
 * Set the value of Parse object field to a Parse pointer (it mutates the object).
 * @category Synchronous.
 * @param {ParseObject} parseObject - The Parse object with the field that must be set.
 * @param {String} fieldName - The name of the field.
 * @param {String} pointerId - The objectId of the object pointed by the Parse pointer.
 * @param {String} pointerClassName - The class name of the pointed object.
 */
var setPointer = exports.setPointer = function setPointer(parseObject, fieldName, pointerId, pointerClassName) {
  var pointer = createPointerFromId(pointerClassName, pointerId);
  setField(parseObject, fieldName, pointer);
};

/**
 * Set the value of Parse object field to an array of pointers (it mutates the object).
 * @category Synchronous.
 * @param {ParseObject} parseObject - The object that with field that must be set.
 * @param {String} fieldName - The name of the field
 * @param {String[]} pointersIds - The objectIds of the objects pointed by the Parse pointers.
 * @param {String} pointersClassName - The class name of the pointed objects.
 */
var setArrayOfPointers = exports.setArrayOfPointers = function setArrayOfPointers(parseObject, fieldName, pointersIds, pointersClassName) {
  var arrayOfPointers = void 0;
  if ((0, _lodash.isArray)(pointersIds) && !(0, _lodash.isEmpty)(pointersIds)) {
    var dirtyArrayOfPointers = pointersIds.map(function (objectId) {
      return createPointerFromId(pointersClassName, objectId);
    });
    arrayOfPointers = (0, _lodash.compact)(dirtyArrayOfPointers);
  }
  setField(parseObject, fieldName, arrayOfPointers);
};

/**
 * Upload a file.
 * @category Asynchronous.
 * @param {String} fileName
 * @param {File} file
 * @return {ParseObject} The uploaded file.
 */
var uploadFile = exports.uploadFile = function () {
  var _ref = _asyncToGenerator(regeneratorRuntime.mark(function _callee(fileName, file) {
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return new Parse.File(fileName, file).save();

          case 2:
            return _context.abrupt('return', _context.sent);

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function uploadFile(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * Get a User given its email.
 * @category Asynchronous.
 * @param {String} userEmail
 * @return {ParseUser} The User object.
 */
var getUserByEmail = exports.getUserByEmail = function () {
  var _ref2 = _asyncToGenerator(regeneratorRuntime.mark(function _callee2(userEmail) {
    var User;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            User = Parse.Object.extend('_User');
            _context2.next = 3;
            return new Parse.Query(User).equalTo('email', userEmail).first();

          case 3:
            return _context2.abrupt('return', _context2.sent);

          case 4:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function getUserByEmail(_x3) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Get a User given its id.
 * @category Asynchronous.
 * @param {String} userId
 * @return {ParseUser} The User object.
 */
var getUserById = exports.getUserById = function () {
  var _ref3 = _asyncToGenerator(regeneratorRuntime.mark(function _callee3(userId) {
    var User;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            User = Parse.Object.extend('_User');
            _context3.next = 3;
            return new Parse.Query(User).equalTo('objectId', userId).first();

          case 3:
            return _context3.abrupt('return', _context3.sent);

          case 4:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function getUserById(_x4) {
    return _ref3.apply(this, arguments);
  };
}();

/**
 * Get a Role given its name.
 * @category Asynchronous.
 * @param {String} roleName
 * @return {ParseObject} The Role object.
 */
var getRoleByName = exports.getRoleByName = function () {
  var _ref4 = _asyncToGenerator(regeneratorRuntime.mark(function _callee4(roleName) {
    var Role;
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            Role = Parse.Object.extend('_Role');
            _context4.next = 3;
            return new Parse.Query(Role).equalTo('name', roleName).first();

          case 3:
            return _context4.abrupt('return', _context4.sent);

          case 4:
          case 'end':
            return _context4.stop();
        }
      }
    }, _callee4, undefined);
  }));

  return function getRoleByName(_x5) {
    return _ref4.apply(this, arguments);
  };
}();

/**
 * Execute a "find" Parse Query regardless of the limit imposed by Parse (which is 500).
 * @category Asynchronous.
 * @param {ParseQuery} parseQuery - The "find" Parse Query that will be executed.
 * @param {Object} options - Options passed to the "find" and "count" functions.
 * @return {ParseObject[]} The array with the found Parse objects.
 */
var findAll = exports.findAll = function () {
  var _ref5 = _asyncToGenerator(regeneratorRuntime.mark(function _callee5(parseQuery, options) {
    var PAGE_SIZE, count, pagesCount, pages;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            PAGE_SIZE = 500;
            _context5.next = 3;
            return parseQuery.count(options);

          case 3:
            count = _context5.sent;
            pagesCount = Math.ceil(count / PAGE_SIZE);
            pages = (0, _lodash.range)(0, pagesCount);
            _context5.next = 8;
            return Promise.all(pages.map(function (page) {
              return parseQuery.skip(page * PAGE_SIZE).limit(PAGE_SIZE).find(options);
            }));

          case 8:
            _context5.t0 = _context5.sent;
            return _context5.abrupt('return', (0, _lodash.flatten)(_context5.t0));

          case 10:
          case 'end':
            return _context5.stop();
        }
      }
    }, _callee5, undefined);
  }));

  return function findAll(_x6, _x7) {
    return _ref5.apply(this, arguments);
  };
}();

/**
 * Execute a "destroyAll" Parse Query without the limitation imposed by Parse.
 * @category Asynchronous.
 * @param {ParseQuery} parseQuery - The "destroy" Parse Query that will be executed.
 * @param {Object} options - Options passed to the "find" and "destroyAll" functions.
 * @return {ParseObject[]} The array with the found Parse objects. TODO
 */
var deleteAllByQuery = exports.deleteAllByQuery = function () {
  var _ref6 = _asyncToGenerator(regeneratorRuntime.mark(function _callee6(parseQuery, options) {
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return _destroyAll(parseQuery.limit(500), options);

          case 2:
            return _context6.abrupt('return', _context6.sent);

          case 3:
          case 'end':
            return _context6.stop();
        }
      }
    }, _callee6, undefined);
  }));

  return function deleteAllByQuery(_x8, _x9) {
    return _ref6.apply(this, arguments);
  };
}();

var _destroyAll = function () {
  var _ref7 = _asyncToGenerator(regeneratorRuntime.mark(function _callee7(parseQuery, options) {
    var count;
    return regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.next = 2;
            return _deleteChunk(parseQuery, options);

          case 2:
            count = _context7.sent;

            if (!count) {
              _context7.next = 9;
              break;
            }

            _context7.next = 6;
            return _destroyAll(parseQuery, options);

          case 6:
            _context7.t0 = _context7.sent;
            _context7.next = 10;
            break;

          case 9:
            _context7.t0 = Parse.Promise.as();

          case 10:
            return _context7.abrupt('return', _context7.t0);

          case 11:
          case 'end':
            return _context7.stop();
        }
      }
    }, _callee7, undefined);
  }));

  return function _destroyAll(_x10, _x11) {
    return _ref7.apply(this, arguments);
  };
}();

var _deleteChunk = function () {
  var _ref8 = _asyncToGenerator(regeneratorRuntime.mark(function _callee8(parseQuery, options) {
    var objectsToDelete, deletedObjects;
    return regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.next = 2;
            return parseQuery.find(options);

          case 2:
            objectsToDelete = _context8.sent;
            _context8.next = 5;
            return Parse.Object.destroyAll(objectsToDelete, options);

          case 5:
            deletedObjects = _context8.sent;
            return _context8.abrupt('return', deletedObjects.length);

          case 7:
          case 'end':
            return _context8.stop();
        }
      }
    }, _callee8, undefined);
  }));

  return function _deleteChunk(_x12, _x13) {
    return _ref8.apply(this, arguments);
  };
}();

/**
 * Execute a "saveAll" Parse Query splitting in chunks the saveAll instructions.
 * @category Asynchronous.
 * @param {ParseObject[]} parseObjects - The array of Parse object that will be saved.
 * @param {Object} saveOptions - Options passed to the "saveAll" function.
 * @param {Number} chunkSize - The chunk size of the promises.
 * @return {ParseObject[]} An array with the saved Parse Objects
 */
var saveAllInChunks = exports.saveAllInChunks = function () {
  var _ref9 = _asyncToGenerator(regeneratorRuntime.mark(function _callee9(parseObjects, options, chunkSize) {
    var objectsChunks, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, singleChunk, chunkResult;

    return regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            objectsChunks = (0, _lodash.chunk)(parseObjects, chunkSize || 200);
            result = [];
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _iteratorError = undefined;
            _context9.prev = 5;
            _iterator = objectsChunks[Symbol.iterator]();

          case 7:
            if (_iteratorNormalCompletion = (_step = _iterator.next()).done) {
              _context9.next = 16;
              break;
            }

            singleChunk = _step.value;
            _context9.next = 11;
            return Parse.Object.saveAll(singleChunk, options);

          case 11:
            chunkResult = _context9.sent;

            result.push(chunkResult);

          case 13:
            _iteratorNormalCompletion = true;
            _context9.next = 7;
            break;

          case 16:
            _context9.next = 22;
            break;

          case 18:
            _context9.prev = 18;
            _context9.t0 = _context9['catch'](5);
            _didIteratorError = true;
            _iteratorError = _context9.t0;

          case 22:
            _context9.prev = 22;
            _context9.prev = 23;

            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }

          case 25:
            _context9.prev = 25;

            if (!_didIteratorError) {
              _context9.next = 28;
              break;
            }

            throw _iteratorError;

          case 28:
            return _context9.finish(25);

          case 29:
            return _context9.finish(22);

          case 30:
            return _context9.abrupt('return', result);

          case 31:
          case 'end':
            return _context9.stop();
        }
      }
    }, _callee9, undefined, [[5, 18, 22, 30], [23,, 25, 29]]);
  }));

  return function saveAllInChunks(_x14, _x15, _x16) {
    return _ref9.apply(this, arguments);
  };
}();

/**
 * Create a Role with the specified name (only if it doesn't alrady exists).
 * @category Asynchronous.
 * @param {String} roleName - The Role name.
 * @param {Object} saveOptions - Options passed to the "save" command.
 * @return {ParseRole} - The created Role (undefined if the role already exists).
 */
var createRoleIfNotExists = exports.createRoleIfNotExists = function () {
  var _ref10 = _asyncToGenerator(regeneratorRuntime.mark(function _callee10(roleName, saveOptions) {
    var Role, doesRoleExists, role, acl;
    return regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            Role = Parse.Object.extend('_Role');
            _context10.next = 3;
            return new Parse.Query(Role).equalTo('name', roleName).first();

          case 3:
            doesRoleExists = _context10.sent;

            if (!doesRoleExists) {
              _context10.next = 8;
              break;
            }

            return _context10.abrupt('return', undefined);

          case 8:
            role = new Role();

            role.set('name', roleName);
            acl = new Parse.ACL();

            acl.setPublicReadAccess(true);
            acl.setPublicWriteAccess(false);
            role.setACL(acl);
            _context10.next = 16;
            return role.save({}, saveOptions);

          case 16:
            return _context10.abrupt('return', _context10.sent);

          case 17:
          case 'end':
            return _context10.stop();
        }
      }
    }, _callee10, undefined);
  }));

  return function createRoleIfNotExists(_x17, _x18) {
    return _ref10.apply(this, arguments);
  };
}();

/**
 * Check if the the user is in a certain role.
 * @category Asynchronous.
 * @param {String} userId - The user objectId.
 * @param {String} roleName - The role name (either this or roleId).
 * @param {String} roleId - The role id (either this or roleName).
 * @return {Boolean} - Is the user in the role?
 */
var isUserInRole = exports.isUserInRole = function () {
  var _ref11 = _asyncToGenerator(regeneratorRuntime.mark(function _callee11(userId, roleName, roleId) {
    var user, roleQuery, isInRole;
    return regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            user = createPointerFromId('_User', userId);
            roleQuery = new Parse.Query(Parse.Role);

            roleQuery.equalTo('users', user);

            if (roleName) {
              roleQuery.equalTo('name', roleName);
            } else {
              roleQuery.equalTo('objectId', roleId);
            }

            _context11.next = 6;
            return roleQuery.first();

          case 6:
            isInRole = _context11.sent;
            return _context11.abrupt('return', !(0, _lodash.isEmpty)(isInRole));

          case 8:
          case 'end':
            return _context11.stop();
        }
      }
    }, _callee11, undefined);
  }));

  return function isUserInRole(_x19, _x20, _x21) {
    return _ref11.apply(this, arguments);
  };
}();

/**
 * Given an array of schemas of classes loads them in Parse Server.
 * @category Asynchronous.
 * @param {Object} parseServerDb - The Parse Server DB instance.
 * @param {Array} schemas - Array of schemas in the format [{ name: {}, schema: {}, permissions: {} }, ...].
 * @param {Boolean} shouldUpdate - Should the class be updated if it already exists?
 */
var loadClassesFromSchemas = exports.loadClassesFromSchemas = function () {
  var _ref12 = _asyncToGenerator(regeneratorRuntime.mark(function _callee13(parseServerDb) {
    var schemas = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    var shouldUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var parseServerDbSchema, loadClass, getSchemaChanges;
    return regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            _context13.next = 2;
            return parseServerDb.loadSchema();

          case 2:
            parseServerDbSchema = _context13.sent;

            // Function that load a class in Parse Server
            loadClass = function () {
              var _ref13 = _asyncToGenerator(regeneratorRuntime.mark(function _callee12(className, classSchema, classPermissions) {
                var mergedClassSchema;
                return regeneratorRuntime.wrap(function _callee12$(_context12) {
                  while (1) {
                    switch (_context12.prev = _context12.next) {
                      case 0:
                        _context12.prev = 0;
                        _context12.next = 3;
                        return parseServerDbSchema.addClassIfNotExists(className, classSchema);

                      case 3:
                        _context12.next = 5;
                        return parseServerDbSchema.updateClass(className, {}, classPermissions);

                      case 5:
                        _context12.next = 17;
                        break;

                      case 7:
                        _context12.prev = 7;
                        _context12.t0 = _context12['catch'](0);

                        if (!(_context12.t0.code === 103)) {
                          _context12.next = 16;
                          break;
                        }

                        if (!shouldUpdate) {
                          _context12.next = 14;
                          break;
                        }

                        mergedClassSchema = getSchemaChanges(className, classSchema);
                        _context12.next = 14;
                        return parseServerDbSchema.updateClass(className, mergedClassSchema, classPermissions, parseServerDb);

                      case 14:
                        _context12.next = 17;
                        break;

                      case 16:
                        throw _context12.t0;

                      case 17:
                      case 'end':
                        return _context12.stop();
                    }
                  }
                }, _callee12, undefined, [[0, 7]]);
              }));

              return function loadClass(_x27, _x28, _x29) {
                return _ref13.apply(this, arguments);
              };
            }();
            // Function that sanitize a class that must be updated in Parse Server


            getSchemaChanges = function getSchemaChanges(className, classSchema) {
              var IGNORED_FIELDS = className !== '_User' ? ['objectId', 'createdAt', 'updatedAt', 'ACL'] : ['objectId', 'createdAt', 'updatedAt', 'ACL', 'emailVerified', 'authData', 'username', 'password', 'email'];
              var deletedFields = (0, _lodash.difference)(Object.keys(parseServerDbSchema.data[className]), (0, _lodash.concat)(Object.keys(classSchema), IGNORED_FIELDS));
              var newFields = (0, _lodash.difference)((0, _lodash.concat)(Object.keys(classSchema), IGNORED_FIELDS), Object.keys(parseServerDbSchema.data[className]));
              var newClassSchema = {};
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = deletedFields[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var field = _step2.value;
                  newClassSchema[field] = _extends({}, parseServerDbSchema.data[className][field], { __op: 'Delete' });
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }

              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = newFields[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var _field = _step3.value;
                  newClassSchema[_field] = _extends({}, classSchema[_field], { __op: 'Insert' });
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }

              return newClassSchema;
            };
            // Load all the classes in Parse Server


            _context13.next = 7;
            return Promise.all(schemas.map(function (_ref14) {
              var name = _ref14.name,
                  schema = _ref14.schema,
                  permissions = _ref14.permissions;
              return loadClass(name, schema, permissions);
            }));

          case 7:
          case 'end':
            return _context13.stop();
        }
      }
    }, _callee13, undefined);
  }));

  return function loadClassesFromSchemas(_x22, _x23, _x24) {
    return _ref12.apply(this, arguments);
  };
}();

exports.default = {
  setParseLib: setParseLib,
  initializeParseSDK: initializeParseSDK,
  uploadFile: uploadFile,
  createPointerFromId: createPointerFromId,
  deleteAllByQuery: deleteAllByQuery,
  getObjectWithoutParseAttributes: getObjectWithoutParseAttributes,
  getUserByEmail: getUserByEmail,
  getUserById: getUserById,
  getRoleByName: getRoleByName,
  loadClassesFromSchemas: loadClassesFromSchemas,
  setField: setField,
  setPointer: setPointer,
  setArrayOfPointers: setArrayOfPointers,
  findAll: findAll,
  saveAllInChunks: saveAllInChunks,
  createRoleIfNotExists: createRoleIfNotExists,
  isUserInRole: isUserInRole
};